import React from "react";
import { NavLink } from "react-router-dom";

// @ts-ignore
import logo from "../../assets/images/logo.png";
import { toggleSidebarMobile } from "../../utils/sidebarUtils";

const handleSidebarItemClick = () => {
  const sidebar = document.querySelector(".account-sidebar.active");
  if (sidebar) {
    sidebar.classList.remove("active");
  }
};

export const Sidebar = () => {
  return (
    <div className="account-sidebar">
      <div className="closeMobileSidebarButton" onClick={toggleSidebarMobile}>
        <i className="fas fa-times"></i>
      </div>
      <div className="inner">
        <div className="logo-wrapper">
          <img alt="PJ Construction Design" className="logo" src={logo} />
        </div>

        <div className="sidebar-content">
          {/* Sidebar menu */}
          <ul className="items-wrapper">
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/dashboard"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-house"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/gallery"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-images"></i>
                <span>Gallery</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/consultation-requests"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-clipboard-list"></i>
                <span>Consultations</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/analytics"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-chart-column"></i>
                <span>Analytics</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={handleSidebarItemClick}
                to="/account/theme-files"
                className={({ isActive }) => `item ${isActive ? "active" : ""}`}
              >
                <i className="fa-solid fa-file-code"></i>
                <span>Site Editor</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
